import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledPipe } from './StyledPipe';

export const ExpiredMessage = () => (
  <>
    <FormattedMessage id="mac.licenses.expired" defaultMessage="Expired" />
    {` `}
    <StyledPipe />
  </>
);
